/* eslint-disable no-alert */
import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import MarkerWithLabel from './MarkerWithLabel'
import helpers from '../helpers'

import utils from '../../../utils'

class OrderGuideByCustomer extends React.Component {
  state = {
    selectedOrderKeys: [],
    merchantBranches: [],
    customerOrders: {},
  }

  componentDidMount() {
    const { orders, onMounted } = this.props

    this.generateCustomerOrders(orders)
    onMounted(this)
  }

  componentWillReceiveProps(nextProps) {
    const { orders } = this.props

    if (orders !== nextProps.orders) this.generateCustomerOrders(nextProps.orders)
  }

  onCreateGroup = () => {
    const { createNewGroup } = this.props
    const { selectedOrderKeys } = this.state

    if (selectedOrderKeys.length === 0) {
      alert('Please select order')
      return false
    }

    createNewGroup(selectedOrderKeys)
    return true
  }

  onClearMarkers = () => {
    this.setState({ selectedOrderKeys: [], merchantBranches: [] })
  }

  generateCustomerOrders = orders => {
    const { groupedOrderKeys } = this.props
    const customerOrders = {}
    const orderKeys = Object.keys(orders)
    const orderCount = orderKeys.length

    for (let index = 0; index < orderCount; index += 1) {
      const orderKey = orderKeys[index]
      const order = orders[orderKey]

      if (!groupedOrderKeys.includes(order.key) && order.status !== 'pending') {
        const customerAddressKey = `${order.deliveree}-${order.delivery_address}`

        customerOrders[customerAddressKey] = customerOrders[customerAddressKey] || []
        customerOrders[customerAddressKey].push(order)
      }
    }

    this.setState({ customerOrders })
  }

  onCustomerAddressClick = customer => {
    const { customerOrders } = this.state
    const orders = customerOrders[customer]

    orders.forEach(this.onOrderSelected)
  }


  onOrderSelected = order => {
    const { key } = order
    const { selectedOrderKeys, merchantBranches } = this.state
    const newSelectedOrderKeys = Array.from(selectedOrderKeys)
    const newMerchantBranches = Array.from(merchantBranches)
    const index = selectedOrderKeys.indexOf(key)

    if (index > -1) {
      newSelectedOrderKeys.splice(index, 1)
      newMerchantBranches.splice(index, 1)
    } else {
      newSelectedOrderKeys.push(key)
      newMerchantBranches.push({
        key: order.restaurant.branch.key,
        location: order.etaInfo.info.legs[0].start_location,
        name: `${order.restaurant.name} - ${order.restaurant.branch.name}`,
      })
    }

    this.setState({ selectedOrderKeys: newSelectedOrderKeys, merchantBranches: newMerchantBranches })
  }

  renderCustomerMarker = customerAddress => {
    const { customerOrders, selectedOrderKeys } = this.state
    const orders = customerOrders[customerAddress]
    const order = orders[0]
    const isActive = selectedOrderKeys.includes(order.key)
    const label = isActive ? orders[0].deliveree_name : null

    return (
      <MarkerWithLabel
        key={customerAddress}
        opacity={isActive ? 1 : 0.4}
        location={order.etaInfo.info.legs[0].end_location}
        icon={helpers.icons.deliveryLocation}
        label={label}
        labelColor={helpers.getLabelColor('available')}
        onClick={() => this.onCustomerAddressClick(customerAddress)}
      />
    )
  }

  renderMerchantMarker = branchOrders => {
    const { key, name, location } = branchOrders[0]
    const label = branchOrders.length > 1 ? `${name} (${branchOrders.length})` : name

    return (
      <MarkerWithLabel
        key={key}
        location={location}
        icon={helpers.icons.restaurant}
        label={label}
        labelColor={helpers.getLabelColor()}
      />
    )
  }

  render() {
    const { merchantBranches, customerOrders } = this.state

    const groupedMerchantBranches = _.groupBy(merchantBranches, merchantBranch => merchantBranch.key)
    const branchKeys = Object.keys(groupedMerchantBranches)
    const branchCount = branchKeys.length

    const customerAddresses = Object.keys(customerOrders)
    const customerCount = customerAddresses.length

    const displayMarkers = []

    for (let index = 0; index < customerCount; index += 1) {
      const customerAddress = customerAddresses[index]
      displayMarkers.push(this.renderCustomerMarker(customerAddress))
    }

    for (let index = 0; index < branchCount; index += 1) {
      const branchKey = branchKeys[index]
      const branchOrders = groupedMerchantBranches[branchKey];
      displayMarkers.push(this.renderMerchantMarker(branchOrders))
    }

    return displayMarkers
  }
}

const mapState = ({ orders }) => {
  const deliveryOrders = _.filter(orders.todayOrders.attention, order => order.order_type !== 'pick-up')

  return {
    orders: utils.helpers.convertArrayToObject(deliveryOrders, 'key'),
  }
}

export default connect(mapState)(OrderGuideByCustomer)



// WEBPACK FOOTER //
// ./src/containers/mapView/components/OrderGuideByCustomer.js